import { codeSplit } from 'bernie-core';

export const CuratedTripsTabMap = codeSplit(
  () => import(/* webpackChunkName: "CuratedTabModule" */ '../curated-tab') as any
);
